<template>
  <div>
    <b-modal id="modal-order" ref="modal" title="" :ok-title="errorSize ? 'Закрити' : 'Зберегти'" cancel-title="Закрити"
      v-model="visible" :ok-only="errorSize" :ok-disabled="!is1cConnected && !errorSize" header-close-content=""
      @hidden="resetModal" @ok="handleOk" modal-class="order-modal-v2" size="md">

      <template v-if="errorSize">
        <div class="error-content-v2">
          <div class="error-icon-v2">
            <i class="fa fa-exclamation-triangle"></i>
          </div>
          <h5 class="error-title-v2">Параметри не збігаються</h5>
          <p class="error-message-v2">
            Параметр "Розмір з Кромкою" має бути однаковий у всіх виробах.
            Будь ласка, зробіть необхідні зміни.
          </p>
        </div>
      </template>

      <template v-else>
        <div class="modal-content-v2">
          <div class="section-v2">
            <h4 class="section-title-v2">
              <i class="fa fa-calculator"></i>
              Кількість виробів
            </h4>
            <div class="products-grid-v2">
              <div v-for="product in products" :key="product.id" class="product-item-v2">
                <label class="product-label-v2" :for="'product_' + product.id">
                  {{ product.name }}
                </label>
                <input type="text" @keypress="onlyNumber" :id="'product_' + product.id" class="product-input-v2"
                  :disabled="!is1cConnected" v-model.number="product.count" placeholder="К-ть" />
              </div>
            </div>
          </div>

          <div class="section-v2">
            <h4 class="section-title-v2">
              <i class="fa fa-cog"></i>
              Параметри замовлення
            </h4>
            <div class="checkboxes-grid-v2">
              <div class="checkbox-item-v2">
                <input type="checkbox" class="checkbox-input-v2" id="customer_material" :disabled="!is1cConnected"
                  v-model="order.customer_material">
                <label for="customer_material" class="checkbox-label-v2">
                  <i class="fa fa-cube"></i>
                  Матеріал Клієнта
                </label>
              </div>
              <div class="checkbox-item-v2">
                <input type="checkbox" class="checkbox-input-v2" id="customer_edge" :disabled="!is1cConnected"
                  v-model="order.customer_edge">
                <label for="customer_edge" class="checkbox-label-v2">
                  <i class="fa fa-border-style"></i>
                  Кромка Клієнта
                </label>
              </div>
              <div class="checkbox-item-v2">
                <input type="checkbox" class="checkbox-input-v2" id="glue" :disabled="!is1cConnected"
                  v-model="order.glue">
                <label for="glue" class="checkbox-label-v2">
                  <i class="fa fa-spray-can"></i>
                  Оклеювання клеєм PUR
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-if="!is1cConnected && connectionText" class="connection-status">
        <i class="fa fa-plug"></i>
        <span>{{ connectionText }}</span>
      </div>

    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import appconfig from "../../app/config";

export default {
  props: [
    'visible',
    'products',
    'orderData', 'errorSize'
  ],
  data() {
    return {
      order: {
        customer_material: this.orderData?.customer_material || false,
        customer_edge: this.orderData?.customer_edge || false,
        edge_size: this.orderData?.edge_size || false,
        glue: this.orderData?.glue || false,
      },
      connection: {
        connected: true,
        text: '',
        checkedAt: null
      },
      connectionIntervalId: null
    }
  },
  computed: {
    is1cConnected() {
      return this.connection.connected === true;
    },
    connectionText() {
      return this.connection.text || '';
    }
  },
  methods: {
    async fetch1cConnection() {
      try {
        const response = await axios.get(appconfig.Point + 'api/constructor/v1/1c/connection');
        const data = response.data || {};
        this.connection.connected = !!data.connected;
        this.connection.text = data.text || '';
        this.connection.checkedAt = data.checked_at || null;
      } catch (e) {
        this.connection.connected = false;
        this.connection.text = '';
        this.connection.checkedAt = null;
      }
    },
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },
    resetModal() {
      this.$emit('on-close')
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit() {
      this.$emit('on-submit', this.order, this.products);
    }
  },
  created() {
    this.fetch1cConnection();
    this.connectionIntervalId = setInterval(this.fetch1cConnection, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.connectionIntervalId) {
      clearInterval(this.connectionIntervalId);
      this.connectionIntervalId = null;
    }
  }
}
</script>

<style scoped>
/* Compact Order Modal Styles */
.order-modal-v2 .modal-dialog {
  max-width: 480px;
  margin: 1.5rem auto;
}

.order-modal-v2 .modal-content {
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.order-modal-v2 .modal-header {
  background: #2c5aa0;
  color: white;
  border: none;
  padding: 12px 16px;
}

.order-modal-v2 .modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.order-modal-v2 .modal-body {
  padding: 16px;
  background: white;
}

.order-modal-v2 .modal-footer {
  background: #f8f9fa;
  border: none;
  padding: 12px 16px;
  gap: 8px;
}

/* Connection Status */
.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 16px 0;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff4f4;
  color: #b02a37;
  font-size: 0.85rem;
  border: 1px solid #f5c2c7;
}

.connection-status i {
  font-size: 0.9rem;
}

/* Error Content */
.error-content-v2 {
  text-align: center;
  padding: 12px;
}

.error-icon-v2 {
  font-size: 2rem;
  color: #dc3545;
  margin-bottom: 10px;
}

.error-title-v2 {
  color: #dc3545;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 1rem;
}

.error-message-v2 {
  color: #6c757d;
  font-size: 0.85rem;
  line-height: 1.4;
  margin: 0;
}

/* Modal Content */
.modal-content-v2 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-v2 {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
}

.section-title-v2 {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #2c5aa0;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.section-title-v2 i {
  font-size: 0.85rem;
}

/* Products Grid */
.products-grid-v2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-item-v2 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.product-label-v2 {
  flex: 1;
  font-weight: 500;
  color: #2c3e50;
  margin: 0;
  font-size: 0.85rem;
}

.product-input-v2 {
  width: 60px;
  padding: 6px 8px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-size: 0.8rem;
  text-align: center;
  transition: all 0.3s ease;
}

.product-input-v2:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

/* Checkboxes Grid */
.checkboxes-grid-v2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.checkbox-item-v2 {
  position: relative;
}

.checkbox-input-v2 {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label-v2 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #495057;
  margin: 0;
  font-size: 0.85rem;
}

.checkbox-label-v2:hover {
  background: #f8f9fa;
  border-color: #2c5aa0;
}

.checkbox-input-v2:checked+.checkbox-label-v2 {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.checkbox-label-v2 i {
  font-size: 0.8rem;
  width: 16px;
  text-align: center;
}

/* Modal Buttons */
.order-modal-v2 .btn {
  padding: 8px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.order-modal-v2 .btn-primary {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.order-modal-v2 .btn-primary:hover {
  background: #1e4a8a;
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.order-modal-v2 .btn-secondary {
  background: #6c757d;
  border-color: #6c757d;
  color: white;
}

.order-modal-v2 .btn-secondary:hover {
  background: #5a6268;
  border-color: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .order-modal-v2 .modal-dialog {
    margin: 1rem;
    max-width: none;
  }

  .product-item-v2 {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  .product-input-v2 {
    width: 100%;
  }
}
</style>
